const getArrayValue = <T>(value: T[] | null | undefined): T[] => value ?? ([] as T[]);

export default getArrayValue;
